import React from 'react'
import { Auth0Provider } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import { auth0Config } from '@/config/auth0'

const Auth0ProviderWithNavigate: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const navigate = useNavigate()

  const onRedirectCallback = (appState?: { returnTo?: string }) => {
    // Clean navigation after Auth0 callback - don't preserve ?code= query params
    const returnTo = appState?.returnTo?.startsWith('/')
      ? appState.returnTo
      : `${window.location.pathname}${window.location.search}${window.location.hash}`
    navigate(returnTo, { replace: true })
  }

  return (
    <Auth0Provider
      domain={auth0Config.domain}
      clientId={auth0Config.clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: auth0Config.audience,
        scope: auth0Config.scope,
        'ext-returnPath': auth0Config['ext-returnPath'],
        'ext-redirectURI': auth0Config['ext-redirectURI']
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}

export default Auth0ProviderWithNavigate
